import {
  useGetAllExercise,
  useGetCombinedExercises,
  useGetExerciseCategory,
  useGetMyLibraryExercises,
} from '_api';
import { useMemo } from 'react';

const useExercise = ({
  page = 0,
  size = 1000,
}: { page?: number; size?: number } = {}) => {
  const { data: allExercise, isFetching: isLoading } = useGetAllExercise({
    page,
    size,
  });
  const { data: exerciseCategory, isFetching: isFetchingExerciseCategory } =
    useGetExerciseCategory({});

  const { data: sharedExercises } = useGetMyLibraryExercises({
    page,
    size,
  });

  const { data: combinedExercises } = useGetCombinedExercises({
    page,
    size,
  });

  const availableExercises = useMemo(() => {
    if (allExercise && sharedExercises) {
      const sortedArray = allExercise
        .concat(sharedExercises)
        .sort((x, y) => x.title.localeCompare(y.title));
      return sortedArray;
    } else if (allExercise) {
      return allExercise;
    } else {
      sharedExercises;
    }
  }, [allExercise, sharedExercises]);

  const availableExercisesOption = useMemo(
    () =>
      availableExercises
        ? availableExercises.map((exercise) => ({
            name: exercise.id,
            description: exercise.title,
          }))
        : [],
    [availableExercises],
  );

  const exerciseOptions = useMemo(
    () =>
      allExercise
        ? allExercise.map((exercise) => ({
            name: exercise.id,
            description: exercise.title,
          }))
        : [],
    [allExercise],
  );

  const exerciseCategoryOptions = useMemo(
    () =>
      exerciseCategory
        ? exerciseCategory.map((category) => ({
            name: category.id,
            description: category.title,
          }))
        : [],
    [exerciseCategory],
  );

  const combinedExerciseOptions = useMemo(
    () =>
      combinedExercises
        ? combinedExercises.map((exercise) => ({
            name: exercise.id,
            description: exercise.title,
          }))
        : [],
    [combinedExercises],
  );

  const getExerciseById = (id: number) =>
    availableExercises ? availableExercises.find((ex) => ex.id === id) : undefined;

  return {
    allExercise,
    availableExercises,
    availableExercisesOption,
    combinedExerciseOptions,
    exerciseOptions,
    getExerciseById,
    sharedExercises,
    exerciseCategoryOptions,
    isFetchingExerciseCategory,
    isLoading,
  };
};

export default useExercise;
